module.exports = new __parcel__URL__("GenericErrorNoResults.307e3cc6.svg").toString();